module.exports = __webpack_public_path__ + "media/images/errors_page-db194b14c8ecb631d07d8da51408ce41.png";